import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacintosh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"macintosh, mac"} maskId="square-filled-radius-0-stroke-1-IconMacintosh"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V19H19V22H5V19H4V2ZM19 18V3H5V18H19ZM7 5H17V13H7V5ZM13 15H17V16H13V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMacintosh;
